import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[phx-floating-button]',
  host: {
    class: 'phx-floating-button',
    '[style.position]': `phxFixedPosition ? 'fixed' : 'absolute'`,
    '[style.top]': 'phxTop',
    '[style.right]': `phxFixedPosition ?  phxRight || '70px' : phxRight`,
    '[style.bottom]': `phxFixedPosition ? phxBottom || '24px' : phxBottom`,
    '[style.left]': 'phxLeft',
    '[style.zIndex]': '100',
    '[style.border-radius]': `'var(--phx-web-dimension-radius-half)'`,
    '[style.box-shadow]': `'var(--phx-web-elevation-float)'`
  }
})
export class PhxFloatingButtonDirective {
  @Input() phxFixedPosition?: boolean;
  @Input() phxTop?: string;
  @Input() phxRight?: string;
  @Input() phxBottom?: string;
  @Input() phxLeft?: string;
}
